// Los 16 píxeles de `Icon/matriz-info` `2637:389` e `Icon/matriz-visor`
// `2637:406` (entrega `docs/entregas/2026-10-23-radio-selector-del-visor.md`).
//
// Rejilla de 4 × 4 en una caja de 24: cada píxel de 3,5 × 3,5, empezando en 2
// y avanzando de 5,5 en 5,5 (2 · 7,5 · 13 · 18,5). Los 16 están siempre: los
// encendidos al 100 % y los apagados al 16 % del mismo color. Van en orden de
// lectura, `p00` … `p33`. Los usan `AstraIcon` (dibujo quieto) y
// `SelectorMatriz` (la cascada).
export const PASO = [2, 7.5, 13, 18.5];
export const LADO = 3.5;
export const APAGADO = 0.16;

const ENCENDIDOS = {
  // Filas 1 y 3 enteras, la 2 sin el último y la 4 con los dos primeros.
  "matriz-info": ["00", "01", "02", "03", "10", "11", "12", "20", "21", "22", "23", "30", "31"],
  // Las cuatro esquinas del encuadre y los cuatro del centro.
  "matriz-visor": ["00", "03", "30", "33", "11", "12", "21", "22"],
};

export const PIXELES = PASO.flatMap((y, fila) => PASO.map((x, columna) => ({ fila, columna, x, y })));

export function encendido(icono, fila, columna) {
  return ENCENDIDOS[icono]?.includes(`${fila}${columna}`) ?? false;
}

// Para `AstraIcon`: un cuadrado por píxel, con su opacidad.
export function trazadosMatriz(icono) {
  return PIXELES.map(({ fila, columna, x, y }) => ({
    d: `M${x} ${y}h${LADO}v${LADO}h-${LADO}z`,
    op: encendido(icono, fila, columna) ? undefined : APAGADO,
  }));
}
